export const isDatadogRumEnabled = () =>
  Boolean(
    process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID && process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
  );

export const getDatadogRumConfig = ({ sessionSampleRate, sessionReplaySampleRate } = {}) => ({
  applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
  clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
  site: process.env.NEXT_PUBLIC_DATADOG_SITE || "datadoghq.com",
  service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
  env: process.env.NEXT_PUBLIC_DD_ENV || process.env.DD_ENV || process.env.NEXT_PUBLIC_ENVIRONMENT,
  // Must match datadog-ci --release-version (see upload-monitoring-sourcemaps.js).
  // Only NEXT_PUBLIC_* is inlined into the browser bundle by Next.js.
  version:
    process.env.NEXT_PUBLIC_MONITORING_RELEASE ||
    process.env.NEXT_PUBLIC_DD_VERSION ||
    process.env.MONITORING_RELEASE ||
    process.env.DD_VERSION ||
    process.env.SENTRY_RELEASE,
  sessionSampleRate: Number(
    sessionSampleRate ?? process.env.NEXT_PUBLIC_DATADOG_SESSION_SAMPLE_RATE ?? 100,
  ),
  sessionReplaySampleRate: Number(
    sessionReplaySampleRate ?? process.env.NEXT_PUBLIC_DATADOG_SESSION_REPLAY_SAMPLE_RATE ?? 0,
  ),
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: "mask-user-input",
});
